"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-1bunet9-0"
})(["visibility:", ";width:", ";height:38px;place-content:flex-end;display:flex;flex-direction:column;z-index:", ";"], function (_ref) {
  var visible = _ref.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref2) {
  var width = _ref2.width;
  return width || '0';
}, function (_ref3) {
  var zIndex = _ref3.zIndex;
  return zIndex || '0';
});

exports.Container = Container;